import { mixins, theme, styled, utils } from 'ui/theme';

export const Button = styled('button')`
  ${mixins.baseFont};
  ${utils.flexbox.row.centerCenter};
  -webkit-tap-highlight-color: transparent;
  background-color: transparent;
  border-radius: ${theme.radii.small};
  border: ${theme.borderWidths.hairline} solid transparent;
  box-sizing: border-box;
  color: ${theme.colors.build.lightLight};
  cursor: pointer;
  display: inline-block;
  font-size: ${theme.fontSizes.md};
  height: ${theme.sizes[12]};
  overflow: hidden;
  padding: ${theme.space[4]};
  position: relative;
  text-align: center;
  text-decoration: none;
  touch-action: manipulation;
  user-select: none;

  /* Border Radius */
  &[data-radius='pill'] {
    border-radius: ${theme.radii.pill};
  }

  &[data-radius='square'] {
    border-radius: ${theme.radii.sharp};
  }

  &[data-size='small'] {
    height: ${theme.sizes[8]};
    padding: ${theme.space[2]};
  }

  &[data-size='large'] {
    height: ${theme.sizes[16]};
    padding: ${theme.space[6]};
  }

  /* Button States */
  &[data-variant='conversion'] {
    background: ${theme.colors.action.conversion.static};

    &:hover {
      background: ${theme.colors.action.conversion.highlight};
    }
  }

  &[data-variant='warning'] {
    background: ${theme.colors.status.error.standard};

    &:hover {
      background: ${theme.colors.status.error.alt};
    }
  }

  /* Width Based on Container */
  &[data-stretch='true'] {
    width: 100%;
  }

  /* Shadow */
  &[data-shadow='close'] {
    box-shadow: ${theme.shadows.down.close};
  }

  &[data-shadow='soft'] {
    box-shadow: ${theme.shadows.down.soft};
  }

  &[data-shadow='medium'] {
    box-shadow: ${theme.shadows.down.mid};
  }

  &[data-shadow='far'] {
    box-shadow: ${theme.shadows.down.far};
  }

  &:disabled {
    background: ${theme.colors.action.navigation.standard.disabled};
    color: ${theme.colors.build.mediumMedium};
    cursor: initial;

    &:hover {
      background: ${theme.colors.action.navigation.standard.disabled};
    }
  }
`;
